import {Component, HostListener, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Constants} from '../../shared/constants.shared';
import {Bank} from '../../interfaces/bank.interface';
import {SessionService} from '../../services/session.service';
import {IdentificationService} from 'src/app/services/identification.service';
import jwtDecode from 'jwt-decode';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'select-bank-page',
  templateUrl: './select-bank.component.html',
  styleUrls: ['./select-bank.component.scss']
})
export class SelectBankComponent {

  banks: Bank[] = [];

  search: string = "";

  inputDocument: boolean = false;
  isPopupVisible: boolean = false;

  @ViewChild('bankNotListedDialog') bankNotListedDialog!: TemplateRef<any>;

  _loadingBanks: boolean = true;

  get filteredBanks() {
    if (!this.banks) return [];
    return this.banks.filter(bank => {
      const name = bank.name.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const search = this.search.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return name.includes(search);
    }).sort((a, b) => (a.name > b.name) ? 1 : -1);
  }

  get mostUsedBanks() {
    if (!this.banks) return [];
    const mostUsed = this.banks.filter(b => b.order);
    return mostUsed.sort((a, b) => a.order > b.order ? 1 : -1);
  }

  constructor(
    private router: Router,
    private session: SessionService,
    private identification: IdentificationService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this._loadingBanks = true;
    this.identification.getBankEntities().subscribe({
    next: res => {
      this.banks = res;
      this._loadingBanks = false;
    },
    error: err => {
      this.identification.handleServiceErrorResponse(err);
      this._loadingBanks = false;
    }
  });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(_: any) {
    return false;
  }

  select(bank: Bank) {

    this.session.bank = bank;

    this.router.navigate([Constants.Path.PERMISSIONS], { queryParams: this.session.operationIdQueryParam() });

  }

  back() {
    this.inputDataCheck();
    if(this.inputDocument){
      this.router.navigate([Constants.Path.PHONE], { queryParams: this.session.operationIdQueryParam() })
    }else{
      this.router.navigate([Constants.Path.IDENTITY_DOC], { queryParams: this.session.operationIdQueryParam() });
    }
  }

  inputDataCheck(): void {
      const token = localStorage.getItem("accessToken");

      if (token) {
        try {
          const decodedToken = jwtDecode<{ phoneNumber?: boolean; identityDocument?: boolean }>(token);

          this.inputDocument= decodedToken.identityDocument === true;

          console.log("phoneHidden:", this.inputDocument);

        } catch (error) {
          console.error("Error decoding token:", error);
        }
      }
    }

    openBankNotListedModal() {
      this.dialog.open(this.bankNotListedDialog, {
        width: '500px'
      });
    }

    confirmBankNotListed() {
      console.log("confirmBankNotListed")
      this.identification.reportBankNotListed("YDOP02").subscribe({
        next: (res) => {
          console.log("res  :" + res)
          this.dialog.closeAll();
          if (res?.urlRedirect) {
            window.location.href = res.urlRedirect;
          } else {
            console.warn("No se recibió urlRedirect en la respuesta.");
          }
        },
        error: err => this.identification.handleServiceErrorResponse(err)

        // error: (err) => {
        //   console.error('Error al reportar banco no listado:', err);
        //   this.dialog.closeAll();
        // }
      });
    }



}
